// 주간 인사이트 조회. 실패해도 개요 화면은 그대로 뜬다 — 인사이트는 덤이다.

import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config/config';

export const useWeeklyInsights = (appUserId, weeks = 4) => {
    const [state, setState] = useState({ weeks: [], loading: true, error: null });

    useEffect(() => {
        if (!appUserId) return undefined;

        let cancelled = false;
        const load = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${API_BASE_URL}/api/patients/${appUserId}/weekly-insights`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { weeks }
                });
                if (!cancelled) setState({ weeks: response.data?.weeks || [], loading: false, error: null });
            } catch (error) {
                if (!cancelled) setState({ weeks: [], loading: false, error });
            }
        };

        load();
        return () => { cancelled = true; };
    }, [appUserId, weeks]);

    return state;
};

export default useWeeklyInsights;
